var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.judgeInfo)?_c('div',{staticClass:"layout-dashboard"},[_c('layout-basic',{attrs:{"title":"评审系统","user":_vm.judgeInfo,"menu":_vm.menuList,"siderWidth":"auto"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }